<!-- Sidebar -->


<div class="filter-layout">
  <div class="fl-header">
    <p class="f-14 font-weight-600 mb-0">Filters</p>
    <div class="d-flex align-items-center">
      <div>
        <button data-testid="auto-app-candidate-filter-button-1" class="hire-btn-secondary mr-3" >Cancel</button>
        <button data-testid="auto-app-candidate-filter-button-2" class="hire-btn-primary">Apply</button>
      </div>
    </div>
  </div>
  <div class="fl-container">
    <form [formGroup]="candidateFilterForm">
      <div class="content-body">
        <div class="row">
          <div class="col-6">
              <div id="collapseOne">
                <div class="position-relative mb-3">
                   <label for="candidatename" class="label-style">Candidate Names</label>
                  <input data-testid="auto-app-candidate-filter-input-1" class="wc-form-control" placeholder="Enter Candidate Name" #candidatenameInput [matAutocomplete]="candidatename"
                    (input)="getTypeaheads('candidatename', $event.target.value)" formControlName="candidatename" (click)="getTypeaheads('candidatename','')">
                    <div *ngIf="showCandidateNameLoader" class="spinner-border position-absolute text-black" style="top:9px; right: 9px; background-color: #fff;" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  <mat-autocomplete #candidatename="matAutocomplete"
                    (optionSelected)="selectOption($event.option.value, 'candidatename')">
                    <mat-option *ngFor="let name of candidateNameRes" [value]="name">{{name.fullname}} <span>
                        </span>
                    </mat-option>
                  </mat-autocomplete>

                </div>
                <div>
                  <span class="wc-ats-chip mr-2 mb-2 text-truncate" *ngFor="let name of selectedName">
                    <div class="d-flex">
                      <span style="display: grid;">
                        <span class="text-truncate" title="{{name?.fullname}}">
                          {{name?.fullname}}
                        </span>
                      </span>

                      <span class="ml-2 pointer " (click)="unselect(name, 'candidate')">
                        <i class="fal fa-times"></i></span>
                    </div>
                  </span>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div id="collapseTwo" >
                <div class="position-relative mb-3">
                  <label for="currentjobtitle" class="label-style"> Current Job Title</label>
                  <input data-testid="auto-app-candidate-filter-input-2" class="wc-form-control" placeholder="Enter Current Job Title"  [matAutocomplete]="current_jobtitle"
                    (input)="getTypeaheads('jobtitle', $event.target.value)" formControlName="currentjobtitle" (click)="getTypeaheads('jobtitle','')">
                    <div *ngIf="showJobtitleLoader" class="spinner-border position-absolute text-black" style="top:9px; right: 9px; background-color: #fff;" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  <mat-autocomplete #current_jobtitle="matAutocomplete"
                    (optionSelected)="selectOption($event.option.value, 'jobtitle')">
                    <mat-option *ngFor="let job of jobTitleRes" [value]="job">{{job?.jobtitle}} ({{job?.count}}) <span>
                        </span></mat-option>
                  </mat-autocomplete>

                </div>
                <div>
                  <span class="wc-ats-chip mr-2 mb-2 text-truncate" *ngFor="let jobnamechip of selectedJobTitle">
                    <div class="d-flex">
                      <span style="display: grid;">
                        <span class="text-truncate" title="{{jobnamechip?.jobtitle}}">
                          {{jobnamechip?.jobtitle}}
                        </span>
                      </span>

                      <span class="ml-2 pointer " (click)="unselect(jobnamechip, 'jobtitle')">
                        <i class="fal fa-times"></i></span>
                    </div>
                  </span>
                </div>
              </div>
            </div>
            </div>

            <!-- Current company -->
            <div class="row">
              <div class="col-6">
                <div class="card bt">
                  <div class="card-header" id="headingThree">
                    <h5 class="mb-0">
                      <button data-testid="auto-app-candidate-filter-button-3" class="btn btn-link px-0 collapsed f-14 w-100 text-left">
                        <span class="position-relative font-weight-500"> Current Company
                    </span>
                        <span class="wcAccordianUpDownArrow text-webbtree-green">
                          <span class="test1"><i class="far fa-angle-up f-14 font-weight-500"></i></span>
                      <span class="test2"> <i class="far fa-angle-down font-weight-500 f-14"></i></span>
                    </span>
                  </button>
                </h5>
              </div>

              <div id="collapseThree">
                <div class="position-relative mb-3">
                  <input data-testid="auto-app-candidate-filter-input-3" class="wc-form-control" placeholder="Enter Current Company" [matAutocomplete]="current_company"
                    (input)="getTypeaheads('company', $event.target.value)" formControlName="currentcompany" (click)="getTypeaheads('company','')">
                    <div *ngIf="showCompanyLoader" class="spinner-border position-absolute text-black" style="top:9px; right: 9px; background-color: #fff;" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  <mat-autocomplete #current_company="matAutocomplete"
                    (optionSelected)="selectOption($event.option.value, 'company')">
                    <mat-option *ngFor="let company of companylist" [value]="company">{{company?.companyname}} ({{company?.count}}) <span>
                        </span></mat-option>
                  </mat-autocomplete>

                </div>
                <div>
                  <span class="wc-ats-chip mr-2 mb-2 text-truncate" *ngFor="let chip of selectedcompany">
                    <div class="d-flex">
                      <span style="display: grid;">
                        <span class="text-truncate" title="{{chip?.companyname}}">
                          {{chip?.companyname}}
                        </span>
                      </span>

                      <span class="ml-2 pointer " (click)="unselect(chip, 'company')">
                        <i class="fal fa-times"></i></span>
                    </div>
                  </span>
                </div>
              </div>
            </div>
            </div>
            <div class="col-6">
                <div class="card bt">
              <div class="card-header" id="headingFour">
                <h5 class="mb-0">
                  <button data-testid="auto-app-candidate-filter-button-4" class="btn btn-link px-0 collapsed f-14 w-100 text-left" >
                    <span class="position-relative font-weight-500"> Current Location
                </span>
                    <span class="wcAccordianUpDownArrow text-webbtree-green">
                      <span class="test1"><i class="far fa-angle-up f-14 font-weight-500"></i></span>
                      <span class="test2"> <i class="far fa-angle-down font-weight-500 f-14"></i></span>
                    </span>
                  </button>
                </h5>
              </div>

              <div id="collapseFour">
                <div class="position-relative mb-3">
                  <input data-testid="auto-app-candidate-filter-input-4" class="wc-form-control" placeholder="Enter Current Location"  [matAutocomplete]="current_location"
                    (input)="getTypeaheads('location', $event.target.value)" formControlName="currentlocation" (click)="getTypeaheads('location','')">
                    <div *ngIf="showLocationLoader" class="spinner-border position-absolute text-black" style="top:9px; right: 9px; background-color: #fff;" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  <mat-autocomplete #current_location="matAutocomplete"
                    (optionSelected)="selectOption($event.option.value, 'location')">
                    <mat-option *ngFor="let location of locationRes" [value]="location">{{location?.locationname}}({{location?.count}}) <span>
                        </span></mat-option>
                  </mat-autocomplete>

                </div>
                <div>
                  <span class="wc-ats-chip mr-2 mb-2 text-truncate" *ngFor="let location of selectedLocation">
                    <div class="d-flex">
                      <span style="display: grid;">
                        <span class="text-truncate" title="{{location?.locationname}}">
                          {{location?.locationname}}
                        </span>
                      </span>

                      <span class="ml-2 pointer " (click)="unselect(location, 'location')">
                        <i class="fal fa-times"></i></span>
                    </div>
                  </span>
                </div>
              </div>
            </div>
            </div>
            </div>

            <div class="row">
              <div class="col-6">
    <div class="card bt">
              <div class="card-header" id="headingFive">
                <h5 class="mb-0">
                  <button data-testid="auto-app-candidate-filter-button-5" class="btn btn-link px-0 collapsed f-14 w-100 text-left">
                    <span class="position-relative font-weight-500"> Tags
                </span>
                    <span class="wcAccordianUpDownArrow text-webbtree-green">
                      <span class="test1"><i class="far fa-angle-up f-14 font-weight-500"></i></span>
                      <span class="test2"> <i class="far fa-angle-down font-weight-500 f-14"></i></span>
                    </span>
                  </button>
                </h5>
              </div>

              <div id="collapseFive" >
                <div class="position-relative mb-3">
                  <input data-testid="auto-app-candidate-filter-input-5" class="wc-form-control" placeholder="Enter Tags" [matAutocomplete]="tags_auto" formControlName="tags"
                    (input)="getTypeaheads('tags', $event.target.value)" (click)="getTypeaheads('tags','')">
                    <div *ngIf="showTagLoader" class="spinner-border position-absolute text-black" style="top:9px; right: 9px; background-color: #fff;" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  <mat-autocomplete #tags_auto="matAutocomplete"
                    (optionSelected)="selectOption($event.option.value, 'tags')">
                    <mat-option *ngFor="let tag of taglist" [value]="tag">{{tag?.tagtext}} <span>
                        </span></mat-option>
                  </mat-autocomplete>

                </div>
                <div>
                  <span class="wc-ats-chip mr-2 mb-2 text-truncate" *ngFor="let tags of selectedtags">
                    <div class="d-flex">
                      <span style="display: grid;">
                        <span class="text-truncate">
                          {{tags?.tagtext}}
                        </span>
                      </span>

                      <span class="ml-2 pointer " (click)="unselect(tags, 'tags')">
                        <i class="fal fa-times"></i></span>
                    </div>
                  </span>
                </div>
              </div>
            </div>
              </div>
              <div class="col-6">
                <div class="card bt">
                  <div class="card-header" id="headingFive">
                    <h5 class="mb-0">
                      <button data-testid="auto-app-candidate-filter-button-6" class="btn btn-link px-0 collapsed f-14 w-100 text-left" >
                        <span class="position-relative font-weight-500"> Tags
                    </span>
                        <span class="wcAccordianUpDownArrow text-webbtree-green">
                          <span class="test1"><i class="far fa-angle-up f-14 font-weight-500"></i></span>
                          <span class="test2"> <i class="far fa-angle-down font-weight-500 f-14"></i></span>
                        </span>
                      </button>
                    </h5>
                  </div>

                  <div id="collapseFive" >
                    <div class="position-relative mb-3">
                      <input data-testid="auto-app-candidate-filter-input-6" class="wc-form-control" placeholder="Enter Tags" [matAutocomplete]="tags_auto" formControlName="tags"
                        (input)="getTypeaheads('tags', $event.target.value)" (click)="getTypeaheads('tags','')">
                        <div *ngIf="showTagLoader" class="spinner-border position-absolute text-black" style="top:9px; right: 9px; background-color: #fff;" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                      <mat-autocomplete #tags_auto="matAutocomplete"
                        (optionSelected)="selectOption($event.option.value, 'tags')">
                        <mat-option *ngFor="let tag of taglist" [value]="tag">{{tag?.tagtext}} <span>
                            </span></mat-option>
                      </mat-autocomplete>

                    </div>
                    <div>
                      <span class="wc-ats-chip mr-2 mb-2 text-truncate" *ngFor="let tags of selectedtags">
                        <div class="d-flex">
                          <span style="display: grid;">
                            <span class="text-truncate">
                              {{tags?.tagtext}}
                            </span>
                          </span>

                          <span class="ml-2 pointer " (click)="unselect(tags, 'tags')">
                            <i class="fal fa-times"></i></span>
                        </div>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-6">
      <div class="card bt">
              <div class="card-header" id="headingsix">
                <h5 class="mb-0">
                  <button data-testid="auto-app-candidate-filter-button-7" class="btn btn-link px-0 collapsed f-14 w-100 text-left" >
                    <span class="position-relative font-weight-500"> Contact Requested
                </span>
                    <span class="wcAccordianUpDownArrow text-webbtree-green">
                      <span class="test1"><i class="far fa-angle-up f-14 font-weight-500"></i></span>
                      <span class="test2"> <i class="far fa-angle-down font-weight-500 f-14"></i></span>
                    </span>
                  </button>
                </h5>
              </div>
              <div id="collapseSix">
                <div class="position-relative mb-3">

                        <!-- complete this  and add add appropriate bootstrap class for multiselect-->
                        <div class="position-relative mb-3">

                          <div class="multi-select-container">
                            <div *ngFor="let option of multiSelectOptions" class="multi-select-option">

                              <div>
                                <label class="wc-checkbox mb-0">
                                  <input data-testid="auto-app-candidate-filter-input-7"  type="checkbox"
                                  [checked]="selectedContactRequest.includes(option)"
                                  (change)="toggleOption(option)" id="mycheck" name="mycheck">
                                  <i class="fas fa-check" style="border-color: #2e93a1 ;"> </i>
                                </label>
                                {{ option }}
                              </div>
                            </div>
                          </div>
                        </div>

                    </div>
                <div>
                  <span class="wc-ats-chip mr-2 mb-2 text-truncate" *ngFor="let tags of selectedtags">
                    <div class="d-flex">
                      <span style="display: grid;">
                        <span class="text-truncate">
                          {{tags?.tagtext}}
                        </span>
                      </span>

                      <span class="ml-2 pointer " (click)="unselect(tags, 'tags')">
                        <i class="fal fa-times"></i></span>
                    </div>
                  </span>
                </div>
              </div>


            </div>
              </div>
              <div class="col-6">
  <div class="card bt">
              <div class="card-header" id="headingseven">
                <h5 class="mb-0">
                  <button data-testid="auto-app-candidate-filter-button-8" class="btn btn-link px-0 collapsed f-14 w-100 text-left" >
                    <span class="position-relative font-weight-500"> Contact Status Filter
                </span>
                    <span class="wcAccordianUpDownArrow text-webbtree-green">
                      <span class="test1"><i class="far fa-angle-up f-14 font-weight-500"></i></span>
                      <span class="test2"> <i class="far fa-angle-down font-weight-500 f-14"></i></span>
                    </span>
                  </button>
                </h5>
              </div>
              <div id="collapseSeven">
                <div class="position-relative mb-3">

                        <div class="position-relative mb-3">

                          <div class="multi-select-container">
                            <div *ngFor="let status of contactStatusFilterOptions" class="multi-select-option">

                              <div>
                                <label class="wc-checkbox mb-0">
                                  <input data-testid="auto-app-candidate-filter-input-8"  type="checkbox"
                                  [checked]="selectedStatus.includes(status?.value)"
                                  (change)="toggleStatus(status?.value)" id="mycheck" name="mycheck">
                                  <i class="fas fa-check" style="border-color: #2e93a1 ;"> </i>
                                </label>
                                {{ status?.key }}
                              </div>
                            </div>
                          </div>
                        </div>

                    </div>
                <div>

                </div>
              </div>


            </div>
              </div>
            </div>
      </div>
    </form>
  </div>
</div>

